import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HARVulnerabilityFilter({ setFilter, removeFilter, facets, filters }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="vulnerability"
      filters={filters}
      id="vulnerability"
      label="Vulnerability"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HARVulnerabilityFilter);
